import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import logo from "../assets/images/logoFederfarma.png"
import ButtonWhite from "../components/common/buttonWhite";
import Footer from "../components/common/footer";
import { deleteUser } from "../redux/reducer/LoginReducer";
import { HttpService } from "../services/HttpService";

const SAMLError = () => {
  const { t } = useTranslation();
  const dispact = useDispatch();

  const samlLogout = async () => {
    const { data: idpLogoutUrl } = await HttpService.get(`${process.env.REACT_APP_API}/saml2/federfarma/logout`);
    dispact(deleteUser());
    window.location.href = idpLogoutUrl;
  }

  return (
    <>
      <div className="container">
        <div className="TableCenter h-100 ">
          <div className="Center">
            <div className="col-md-6 col-lg-3 pl-0 pr-0 mx-auto pt-4">
              <div className="text-center">
                <img src={logo} className="mb-4 " alt="Logo" />
              </div>
              <div className="text-danger text-center mt-3">
                {t('error.saml')}
              </div>
              <div className="text-center mt-3">
                <ButtonWhite textButton={t('error.return-to-login')} handleChange={samlLogout} />
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SAMLError;
